import React from 'react';
import { FlaskConical } from 'lucide-react';

const C = { navy: '#0D1B2A', slate: '#5C6B7A', amber: '#E8A020' };

/** Printed wherever a number is derived from claims experience. If any of the book's experience
 *  is seeded, it says so before the figure is read — not in a footnote. */
export const ExperienceProvenance = ({ data, testId = 'experience-provenance' }) => {
  if (!data) return null;
  const seeded = data.seeded;
  return (
    <div
      className="flex items-start gap-2.5 px-3 py-2.5 rounded-md"
      style={{
        background: seeded ? 'rgba(232,160,32,0.07)' : 'rgba(136,150,168,0.06)',
        border: `1px solid ${seeded ? 'rgba(232,160,32,0.3)' : 'rgba(136,150,168,0.16)'}`,
        borderLeft: `3px solid ${seeded ? C.amber : C.slate}`,
      }}
      data-testid={testId}
    >
      <FlaskConical className="w-3.5 h-3.5 mt-0.5 shrink-0" style={{ color: seeded ? C.amber : C.slate }} />
      <div className="min-w-0">
        {seeded && (
          <p className="text-[11px] font-semibold uppercase tracking-wider" style={{ color: C.amber }} data-testid={`${testId}-label`}>
            Seeded experience — {data.share_of_incurred_pct}% of incurred loss
          </p>
        )}
        <p className="text-[11px] leading-relaxed mt-0.5" style={{ color: seeded ? C.navy : C.slate }} data-testid={`${testId}-text`}>
          {data.disclosure}
        </p>
      </div>
    </div>
  );
};

export default ExperienceProvenance;
